<template>
  <div class="news">
    <!-- 视差背景横幅 -->
    <div class="parallax-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1 class="animate__animated animate__fadeInDown">新闻资讯</h1>
        <p class="animate__animated animate__fadeInUp">NEWS & INFORMATION</p>
      </div>
    </div>

    <div class="news-section" v-loading="loading">
      <div class="news-container">
        <el-tabs v-model="activeTab" @tab-click="tabClick">
          <el-tab-pane name="1" label="公司新闻"></el-tab-pane>
          <el-tab-pane name="2" label="行业动态"></el-tab-pane>
        </el-tabs>

        <el-empty description="暂无内容" v-show="isEmpty"></el-empty>

        <div class="news-grid">
          <div class="news-card" v-for="(item, index) in newsList" :key="index"
               @click="jumpNewsDetail(item)">
            <div class="card-image">
              <img :src="item.filePath" :alt="item.title">
            </div>
            <div class="card-content">
              <h3>{{ item.title }}</h3>
              <div class="card-meta">
                <span class="date">
                  <i class="el-icon-date"></i>
                  {{ new Date(item.createTime).toLocaleDateString() }}
                </span>
                <span class="category">
                  <i class="el-icon-folder"></i>
                  {{ item.type === '1' ? '公司新闻' : '行业动态' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="prev, pager, next"
          :total="totalCases"
          class="pagination">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner,
  },
  data() {
    return {
      loading: true,
      newsList: [],
      isEmpty:false,
      currentPage: 1,
      totalCases: 20,
      activeTab: '1'
    };
  },
  methods: {
    changeNewsType(type) {
      this.newstype = type;
      this.loadData();
    },
    jumpNewsDetail(item){
      if(item.isLink=="0"){
        this.$router.push({ name: 'newsdetails', params: { item: item }})
      }else{
        window.open(item.url,'_blank')
      }
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData()
      // 这里可以添加加载更多数据的逻辑
    },
    tabClick(item){
      this.activeTab=item.name
      this.loadData()
    },
    loadData() {
      this.newsList = [];
      this.loading = true;
      this.$http
        .get(`news/GetNewsAll?type=${this.activeTab}&current=${this.currentPage}&size=10`)
        .then((response) => {
          this.newsList = response.data.data.records;
          for (let a of this.newsList) {
            a.filePath = this.imgserver + a.filePath;
          }

          this.loading = false;
          this.totalCases=response.data.data.total
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  background: #fff;

  // 视差背景横幅
  .parallax-banner {
    height: 35vh;
    background: url('../assets/img/bgtop.jpg') center/cover fixed;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }

    .banner-content {
      position: relative;
      z-index: 1;

      h1 {
        font-size: 3rem;
        margin-bottom: 1rem;
        font-weight: 600;
      }

      p {
        font-size: 1.1rem;
        letter-spacing: 0.3rem;
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .news-section {
    margin-top: -40px;
    position: relative;
    z-index: 2;
    padding: 0 0 6rem;

    .news-container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 2rem;
      background: white;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

      :deep(.el-tabs__nav-wrap) {
        &::after {
          height: 0;
        }
      }

      :deep(.el-tabs__nav) {
        display: flex;
        justify-content: center;
        gap: 4rem;
        padding: 2rem 0;
      }

      :deep(.el-tabs__item) {
        font-size: 1.2rem;
        padding: 0 1rem;
        height: 50px;
        line-height: 50px;
        transition: all 0.3s ease;
        border: none;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 3px;
          background: #409EFF;
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        &.is-active {
          color: #409EFF;
          font-weight: 600;

          &::after {
            transform: scaleX(1);
          }
        }

        &:hover {
          color: #409EFF;
        }
      }

      .news-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 2.5rem;
        margin: 3rem 0;
      }

      .news-card {
        background: white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid #f0f0f0;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(64, 158, 255, 0.1);

          .card-image {
            &::after {
              opacity: 1;
            }

            img {
              transform: scale(1.05);
            }
          }

          .card-content h3 {
            color: #409EFF;
          }
        }

        .card-image {
          height: 240px;
          overflow: hidden;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(to bottom, rgba(64, 158, 255, 0.1), transparent);
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          img {
            width: 100%;
            height: 100%;
            object-position: right;
            transition: transform 0.3s ease;
          }
        }

        .card-content {
          padding: 1.8rem;
          background: white;

          h3 {
            font-size: 1.2rem;
            color: #2c3e50;
            margin-bottom: 1.2rem;
            font-weight: 500;
            line-height: 1.4;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            transition: color 0.3s ease;
          }

          .card-meta {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #666;
            font-size: 0.9rem;

            span {
              display: flex;
              align-items: center;
              gap: 0.5rem;

              i {
                font-size: 1rem;
                color: #409EFF;
                opacity: 0.8;
              }
            }
          }
        }
      }

      .pagination {
        text-align: center;
        margin-top: 4rem;
        padding-bottom: 2rem;

        :deep(.el-pagination button) {
          background: none;
          border: 1px solid #eaeaea;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            border-color: #409EFF;
          }
        }

        :deep(.el-pager li) {
          border: 1px solid #eaeaea;
          margin: 0 5px;
          transition: all 0.3s ease;
          
          &.active {
            background: #409EFF;
            color: white;
            border-color: #409EFF;
          }

          &:hover {
            color: #409EFF;
            border-color: #409EFF;
          }
        }
      }

      :deep(.el-tabs__active-bar) {
        display: none !important;
      }
    }
  }

  @media (max-width: 1200px) {
    .news-section .news-container {
      .news-grid {
        grid-template-columns: repeat(2, 1fr);
      }

      :deep(.el-tabs__nav) {
        gap: 2rem;
      }
    }
  }

  @media (max-width: 1200px) {
    .parallax-banner {
      height: 25vh!important;
    }
  }

  @media (max-width: 768px) {
    .parallax-banner {
      height: 25vh;

      .banner-content {
        h1 {
          font-size: 2.2rem;
        }

        p {
          font-size: 0.9rem;
        }
      }
    }

    .news-section {
      margin-top: -40px;
      padding: 0 0 4rem;

      .news-container {
        padding: 0 1rem;

        .tabs-wrapper {
          padding: 1.5rem 0;
        }

        :deep(.el-tabs__nav) {
          gap: 1rem;
        }

        :deep(.el-tabs__item) {
          font-size: 1rem;
          padding: 0 0.5rem;
        }

        .news-grid {
          grid-template-columns: 1fr;
          gap: 1.5rem;
          margin: 2rem 0;
        }

        .news-card {
          .card-image {
            height: 200px;
          }

          .card-content {
            padding: 1.2rem;
          }
        }

        .pagination {
          margin-top: 2rem;
        }
      }
    }
  }
}

// 动画类
.animate__animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.animate__fadeInDown {
  animation-name: fadeInDown;
}

.animate__fadeInUp {
  animation-name: fadeInUp;
}
</style>
